module.exports = __webpack_public_path__ + "static/img/home-bg-mb.41256e8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home-bg-mb.jpg
// module id = JaG3
// module chunks = 1